module.exports = __webpack_public_path__ + "img/ennetix-xvisor-overview.40e18955.png";